import { render, staticRenderFns } from "./ModalTrocaSenha.vue?vue&type=template&id=fec93412"
import script from "./ModalTrocaSenha.vue?vue&type=script&lang=ts"
export * from "./ModalTrocaSenha.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports